import {Component, EventEmitter, Input, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {getTranslation} from 'shared/helpers/get-translation';

@Component({
  selector: 'mc-question',
  templateUrl: 'mc-question.html',
  styleUrls: ['mc-question.scss'],
})
export class McQuestionComponent {

  @Input()
  public title: string;

  @Input()
  public description: string;

  @Input()
  public options: Array<Dictionary<string>>;

  @Input()
  public value: string = '';

  @Input()
  public solution: string = '';

  @Output()
  public valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  public valueOnly: boolean = false;

  constructor(
    public translateService: TranslateService,
  ) { }

  public getOptionText(option: Dictionary<string>): string {
    return getTranslation(option, this.translateService);
  }

  public changeItem(i:number, evt): void {
    this.doChangeItem(i, evt.target.checked);
  }

  public switch(i: number):void {
    this.doChangeItem(i, !this.isChecked(i));
  }

  private doChangeItem(i:number, val: boolean): void {
    while ( this.value.length < i ) {
      this.value += '0'
    }
    // if only one expexted solution, then rect exlusively 
    let s = this.value;
    if ( this.solution !== undefined && this.solution !== '' && this.solution.length == this.solution.replace('1', '').length + 1) {
      s = s.replace('1', '0');
    }
    this.value = s.substring(0, i) + (val ? '1' : '0') + s.substring(i+1);

    console.log(this.value);
    this.valueChange.emit(this.value);
  }

  public isChecked(i: number): boolean {
    return (this.value && this.value.length > i && this.value.charAt(i) == '1') ? true : false;
  }

  public isSolution(i: number): boolean {
    return this.solution && this.solution.length > i && this.solution.charAt(i) == '1';
  }



}
